import { BaseHook } from './base.hook';

export class TenPercentShareholderHook extends BaseHook {

  static path = 'EmploymentInformation.tenPercentShareholder';

  static execute(path, value, actions) {
    const pathsToDelete = [
      'tickerSymbol',
      'Position'
    ];

    if (value === false) {
      for (const path of pathsToDelete) {
        actions.deleteData(`EmploymentInformation.${path}`);
      }
    }
  }
}
